<template>
  <div>
    <header id="page-topbar">
      <div class="navbar-header">
        <div class="d-flex">
          <!-- LOGO -->
          <div class="navbar-brand-box">
            <router-link tag="a" to="/" class="logo ">
              <span class="logo-sm">
                <p class="m-0 p-0" style="font-size:28px;font-weight:bold">
                  X
                </p>
              </span>
              <span class="logo-lg">
                <p class="m-0 p-0" style="font-size:28px;font-weight:bold">
                  Xarid
                </p>
              </span>
            </router-link>

            <!-- <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <p class="m-0 p-0" style="font-size:28px;font-weight:bold">
                X
              </p>
            </span>
            <span class="logo-lg">
              <p class="m-0 p-0" style="font-size:28px;font-weight:bold">
                Xarid
              </p>
            </span>
          </router-link> -->
          </div>

          <!-- App Search-->
          <form class="app-search d-none d-lg-block">
            <div class="position-relative">
              <input
                type="text"
                class="form-control"
                :placeholder="$t('search')"
              />
              <span class="bx bx-search-alt"></span>
            </div>
          </form>
        </div>

        <div class="d-flex">
          <b-dropdown
            class="d-inline-block d-lg-none ms-2"
            variant="black"
            menu-class="dropdown-menu-lg p-0"
            toggle-class="header-item noti-icon"
            right
          >
            <template v-slot:button-content>
              <i class="mdi mdi-magnify"></i>
            </template>

            <form class="p-3">
              <div class="form-group m-0">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search ..."
                    aria-label="Recipient's username"
                  />
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="submit">
                      <i class="mdi mdi-magnify"></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </b-dropdown>

          <b-dropdown variant="white" right toggle-class="header-item">
            <template v-slot:button-content>
              {{ text }}
            </template>
            <b-dropdown-item
              class="notify-item"
              v-for="(entry, i) in languages"
              :key="`Lang${i}`"
              :value="entry"
              @click="setLanguage(entry.language, entry.title, entry.flag)"
              :class="{ active: lan === entry.language }"
            >
              <span class="align-middle">{{ entry.title }}</span>
            </b-dropdown-item>
          </b-dropdown>
          <b-dropdown
            right
            menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
            toggle-class="header-item noti-icon"
            variant="black"
          >
            <template v-slot:button-content>
              <i class="bx bx-basket bx-tada" @click="OpenCartItemModal"></i>
              <span class="badge bg-danger rounded-pill">{{
                selected.length
              }}</span>
            </template>

            <!-- <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h6>
              </div>
              <div class="col-auto">
                <a href="#" class="small">{{
                  $t("navbar.dropdown.notification.subtext")
                }}</a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px">
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs me-3">
                  <span
                    class="avatar-title bg-primary rounded-circle font-size-16"
                  >
                    <i class="bx bx-cart"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.order.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.order.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.order.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <img
                  src="@/assets/images/users/avatar-3.jpg"
                  class="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.james.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.james.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.james.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs me-3">
                  <span
                    class="avatar-title bg-success rounded-circle font-size-16"
                  >
                    <i class="bx bx-badge-check"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.item.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.item.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.item.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <img
                  src="@/assets/images/users/avatar-4.jpg"
                  class="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.salena.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.salena.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.salena.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </simplebar>
          <div class="p-2 border-top d-grid">
            <a
              class="btn btn-sm btn-link font-size-14 text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              {{ $t("navbar.dropdown.notification.button") }}
            </a>
          </div> -->
          </b-dropdown>

          <div class="dropdown d-none d-lg-inline-block ms-1">
            <button
              type="button"
              class="btn header-item noti-icon"
              @click="initFullScreen"
            >
              <i class="bx bx-fullscreen"></i>
            </button>
          </div>
        </div>
      </div>
    </header>
    <b-container style="margin-top:90px">
      <PageHeader :title="title" :items="braedcrumb" />
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="row m-2">
              <div class="col d-flex justify-content-between">
                <div>
                  <b-row>
                    <!-- <b-col
                    cols="12"
                    md="4"
                    class="
                      d-flex
                      align-items-center
                      justify-content-start
                      mb-1 mb-md-0
                    "
                  >
                    
                  </b-col> -->
                    <b-col>
                      <b-input-group>
                        <b-form-input
                          :placeholder="$t('search')"
                          v-model="filter.Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button @click="Refresh" variant="primary">
                            <i class="fas fa-search"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </div>
                <div>
                  <b-button
                    variant="primary"
                    @click="OpenCartItemModal"
                    :disabled="selected.length == 0"
                  >
                    <i class="mdi mdi-telegram"></i> {{ $t("send") }} |
                    <span class="badge bg-success rounded-pill">{{
                      selected.length
                    }}</span>
                  </b-button>
                </div>
              </div>
            </div>
            <b-row class="mx-2">
              <b-col>
                <v-select
                  :options="OblastList"
                  :reduce="(item) => item.id"
                  :placeholder="$t('oblast')"
                  label="name"
                  @input="OblastChange"
                  v-model="filter.OblastId"
                ></v-select>
              </b-col>
              <b-col>
                <v-select
                  :options="RegionList"
                  :reduce="(item) => item.id"
                  :placeholder="$t('region')"
                  label="name"
                  @input="Refresh"
                  v-model="filter.RegionId"
                ></v-select>
              </b-col>
            </b-row>
            <div class="row m-2">
              <div class="col">
                <b-table
                  :fields="fields"
                  bordered
                  :items="items"
                  responsive="sm"
                  :busy="isLoading"
                  head-row-variant="info"
                  select-mode="multi"
                  sticky-header="60vh"
                  no-border-collapse
                  selectable
                  show-empty
                  @row-selected="onRowSelected"
                  selected-variant="success"
                >
                  <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                      <span aria-hidden="true">&check;</span>
                      <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                      <span aria-hidden="true">&nbsp;</span>
                      <span class="sr-only">Not selected</span>
                    </template>
                  </template>
                  <template v-slot:empty>
                    <h5 class="text-center">{{ $t("NoItems") }}</h5>
                  </template>
                  <template #cell(purchasequantity)="{item}">
                    <span style="white-space:nowrap">
                      {{ item.purchasequantity }} ({{ item.unitofmeasurename }})
                    </span>
                  </template>
                  <template v-slot:table-busy>
                    <div
                      class="text-center text-primary my-2"
                      style="vertical-align: middle"
                    >
                      <b-spinner
                        style="margin-right: 10px"
                        class="align-middle"
                      ></b-spinner>
                      <strong>{{ $t("Loading") }}</strong>
                    </div>
                  </template>
                  <template #cell(status)="{ item }">
                    <span
                      :class="
                        `badge rounded-pill bg-${$getItemColor(item)} ms-1`
                      "
                    >
                      {{ item.status }}
                    </span>
                  </template>
                </b-table>
              </div>
            </div>
            <div>
              <b-row class="m-2">
                <b-col
                  cols="12"
                  sm="6"
                  class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-start
                "
                >
                  <span class="text-muted">
                    {{ $t("Showing") }} {{ firstNumber }} {{ $t("to") }}
                    {{ lastNumber }} {{ $t("of") }} {{ filter.totalRows }}
                    {{ $t("entries") }}
                  </span>
                </b-col>
                <b-col
                  cols="12"
                  sm="6"
                  class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-end
                "
                >
                  <multiselect
                    style="width: 100px;margin-right:10px"
                    :show-labels="false"
                    :placeholder="$t('')"
                    v-model="filter.PageLimit"
                    :options="filter.perPageOptions"
                    @input="Refresh"
                    class="per-page-selector d-inline-block"
                  ></multiselect>
                  <b-pagination
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                    @input="Refresh"
                    :per-page="filter.PageLimit"
                    :total-rows="filter.totalRows"
                    v-model="filter.PageNumber"
                  >
                    <template #prev-text>
                      <i class="fas fa-angle-left"></i>
                    </template>
                    <template #next-text>
                      <i class="fas fa-angle-right"></i>
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
              <b-modal
                size="xl"
                :title="$t('selecteditem')"
                no-close-on-backdrop
                v-model="CartItemModal"
                hide-footer
              >
                <b-overlay :show="CartItemLoading">
                  <div role="tablist">
                    <b-card
                      no-body
                      class="mb-1 shadow-none"
                      v-for="(element, index) in CartItemList"
                      :key="index + 'ic'"
                    >
                      <b-card-header header-tag="header" role="tab">
                        <h6 class="m-0" v-b-toggle="'accordion-' + index">
                          <a class="text-dark" href="javascript: void(0);">
                            {{ element.OblastName }}, {{ element.RegionName }},
                            <b> {{ element.OrganizationName }} </b> ({{
                              $t("TotalQuantity")
                            }}
                            : {{ element.TotalQuantity }}) ({{
                              $t("TotalSum")
                            }}
                            : {{ element.TotalSum }} )
                          </a>
                        </h6>
                      </b-card-header>
                      <b-collapse
                        :id="`accordion-${index}`"
                        :visible="index == 0"
                        accordion="my-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <b-overlay :show="ItemLoading">
                            <b-table
                              :fields="fields1"
                              bordered
                              :items="element.tables"
                              responsive="sm"
                              head-row-variant="info"
                              sticky-header="60vh"
                              no-border-collapse
                              show-empty
                              :tbody-tr-class="rowClass"
                              small
                            >
                              <template v-slot:empty>
                                <h5 class="text-center">{{ $t("NoItems") }}</h5>
                              </template>
                              <template #cell(PurchaseQuantity)="{item}">
                                <span style="white-space:nowrap">
                                  {{ item.PurchaseQuantity }} ({{
                                    item.UnitOfMeasureName
                                  }})
                                </span>
                              </template>
                              <template #cell(OfferSum)="{item}">
                                <!-- <b-form-input size="sm" v-model="item.OfferSum"> </b-form-input> -->
                                <custom-number-input
                                  v-if="element.CanSent"
                                  @keyup="CalcTotal(element)"
                                  size="sm"
                                  v-model="item.OfferSum"
                                ></custom-number-input>
                                <span v-if="!element.CanSent">
                                  {{ item.OfferSum }}
                                </span>
                              </template>
                            </b-table>
                          </b-overlay>
                          <b-row>
                            <b-col
                              class="text-right d-flex justify-content-end"
                            >
                              <!-- <b-button @click="CartItemModal = false" variant="danger" size="sm" style="margin-right:10px" class="mr-2"> {{ $t('back') }} </b-button> -->
                              <b-button
                                variant="success"
                                :disabled="
                                  !element.CanSent || element.TotalSum == 0
                                "
                                @click="Send(element)"
                                size="sm"
                              >
                                <b-spinner v-if="SendLoading" small></b-spinner>
                                <span v-if="!SendLoading">{{
                                  $t("send")
                                }}</span>
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                </b-overlay>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Multiselect from "vue-multiselect";
import ReportService from "@/services/reports/report.service";
import PageHeader from "@/components/page-header";
import simplebar from "simplebar-vue";
import PerReqTotalForNextYearService from "@/services/document/purreqtotalfornextyear.service";
import CustomNumberInput from "@/components/CustomNumberInput";
import OblastService from "@/services/info/oblast.service";
import RegionService from "@/services/info/region.service";
export default {
  components: { PageHeader, Multiselect, simplebar, CustomNumberInput },
  data() {
    return {
      languages: [
        {
          language: "ru",
          title: "Русский язык",
        },
        {
          language: "uz_cyrl",
          title: "Ўзбек тили",
        },
        {
          language: "uz_latn",
          title: "O'zbek tili",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      filter: {
        OblastId: 0,
        RegionId: 0,
        ProductCategoryId: 0,
        ProductId: 0,
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 20,
        FinYear: 0,
        perPageOptions: [20, 50, 100, 200],
        totalRows: 0,
      },
      title: this.$t("GetPurchasedProductsList1"),
      braedcrumb: [
        {
          text: this.$t("Report"),
        },
        {
          text: this.$t("GetPurchasedProductsList1"),
          active: true,
        },
      ],
      fields: [
        { key: "selected", label: this.$t("Selected") },
        // { key : 'finyear',label:this.$t('finyear') },
        { key: "oblastname", label: this.$t("oblast") },
        { key: "regionname", label: this.$t("region") },
        { key: "organizationname", label: this.$t("organization") },
        { key: "productcategoryname", label: this.$t("productcategory") },
        { key: "productname", label: this.$t("product") },
        // { key : 'unitofmeasurename',label:this.$t('unitofmeasure') },
        { key: "purchasequantity", label: this.$t("purchasequantity") },
      ],
      fields1: [
        { key: "ProductCategoryName", label: this.$t("productcategory") },
        { key: "ProductName", label: this.$t("product") },
        { key: "PurchaseQuantity", label: this.$t("purchasequantity") },
        { key: "OfferSum", label: this.$t("OfferSum") },
      ],
      items: [],
      isLoading: false,
      selected: [],
      CartItemModal: false,
      CartItemLoading: false,
      CartItemList: [],
      SendLoading: false,
      ItemLoading: false,
      OblastList: [],
      RegionList: [],
    };
  },
  created() {
    // window.location.reload()
    this.Refresh();
    OblastService.GetAll(this.lang).then((res) => {
      this.OblastList = res.data;
    });
  },
  computed: {
    firstNumber() {
      return (this.filter.PageNumber - 1) * this.filter.PageLimit + 1;
    },
    lastNumber() {
      if (this.filter.totalRows < this.filter.PageLimit) {
        return this.filter.totalRows;
      } else {
        if (
          this.filter.PageNumber * this.filter.PageLimit >
          this.filter.totalRows
        ) {
          return this.filter.totalRows;
        } else {
          return this.filter.PageNumber * this.filter.PageLimit;
        }
      }
    },
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    // window.location.reload()
  },
  methods: {
    OblastChange() {
      this.filter.RegionId = 0;
      if (!!this.filter.OblastId) {
        RegionService.GetAll(this.lang, this.filter.OblastId).then((res) => {
          this.RegionList = res.data;
        });
        this.Refresh();
      }
    },
    CalcTotal(item) {
      // console.log(item)
      item.TotalSum = 0;
      item.tables.forEach(function(el) {
        item.TotalSum += el.OfferSum;
      });
    },
    Send(item) {
      this.SendLoading = true;
      item.Status = 1;
      PerReqTotalForNextYearService.SentCommercialOffer(this.CartItemList)
        .then((res) => {
          this.SendLoading = false;
          // this.Refresh()
          // this.RefreshItem()
          // this.CartItemModal = false
          this.CartItemList = res.data.result;
        })
        .catch((res) => {
          this.SendLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    RefreshItem() {
      this.CartItemLoading = true;
      PerReqTotalForNextYearService.GetCommercialOfferList(this.selected)
        .then((res) => {
          this.CartItemLoading = false;
          this.CartItemList = res.data.result;
        })
        .catch((error) => {
          this.CartItemLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    OpenCartItemModal() {
      this.CartItemModal = true;
      this.RefreshItem();
    },
    rowClass(item, type) {
      if (item.Status === 3) return "d-none";
    },
    onRowSelected(items) {
      this.selected = items;
      // this.$store.state.selectedProductList = this.selected
    },
    Refresh() {
      this.isLoading = true;
      ReportService.GetPurchasedProductsList(
        this.filter.OblastId,
        this.filter.RegionId,
        this.filter.ProductCategoryId,
        this.filter.ProductId,
        this.filter.FinYear,
        this.filter.Search,
        this.filter.SortColumn,
        this.filter.OrderType,
        this.filter.PageNumber,
        this.filter.PageLimit
      )
        .then((res) => {
          this.items = res.data.result.rows;
          this.filter.totalRows = res.data.result.total;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
      localStorage.setItem("locale", locale);
      window.location.reload();
    },
  },
};
</script>

<style></style>
